@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.order-import-mappings-rename-modal-body {
  padding: 15px;
  font-size: 13px;
  color: @order-import-mappings-rename-modal--text-color;
}

.order-import-mappings-rename-modal-footer {
  font-size: 13px;
  color: @order-import-mappings-rename-modal--text-color;
}

.order-import-mappings-rename-modal-error {
  padding: 10px 0;
}

.button-group {
  margin-right: 5px;
}

.button-group button {
  margin: 5px;
}
